import styled from 'styled-components';

const X = styled.div`
  rotate: 45deg;
`;

export const Styled = {
  X,
};
